import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_SESSIONS, 
    ADD_NEW_SESSION, 
    UPDATE_SESSION, 
    DELETE_SESSION,

    GET_SESSION_RESULTS, // 

    PROCLAMER_SESSION,

    // PROCLAMATION RESULTS
    GET_PROCLAMATION_RESULTS,
    //GET_PROCLAMATION_RESULT_SUCCESS,
    //GET_PROCLAMATION_RESULT__FAILURE,





    SAVE_FINAL_DECISION,
     GET_FINAL_DECISION,
     RUN_ANNUAL_DELIBERATION


} from "./actionTypes";

import {
    getSessionsSuccess,
    getSessionsFail,
    addSessionSuccess,
    addSessionFail,
    updateSessionSuccess,
    updateSessionFail,
    deleteSessionSuccess,
    deleteSessionFail,

    getSessionResultsSuccess, 
    getSessionResultsFail,     

    proclamerSessionSuccess,
    proclamerSessionFail,

    getProclamationResultsSuccess,      // 🆕
    getProclamationResultsFail,         // 🆕


    saveFinalDecisionSuccess, 
    saveFinalDecisionFail,

    runAnnualDeliberationSuccess, 
    runAnnualDeliberationFail



} from "./actions"

import {

    getSessions,
    addNewSession,
    updateSession,
    deleteSession,

    getSessionResults, 
    proclamerSession as proclamerSessionApi,

    getProclamationResults,  // 🆕

    saveFinalDecision, 
    getFinalDecision,

    runAnnualDeliberation


} from "helpers/sessions/sessions_backend_helper";
import { toast } from "react-toastify";

function* fetchSessions() {
    try {
        const response = yield call(getSessions)

        console.log("FEE TYPES: ", response);
        yield put(getSessionsSuccess(response))
    } catch (error) {
        yield put(getSessionsFail(error))
    }
}

function* onAddNewSession({ payload }) {
    try {

        
        const response = yield call(addNewSession, payload)

        console.log("RESPONSE:", response);
        yield put(addSessionSuccess(response.session))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addSessionFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* onUpdateSession({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateSession, payload)
        yield put(updateSessionSuccess(response.session))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateSessionFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteSession({ payload: data }) {

    try {
        const response = yield call(deleteSession, data)
        yield put(deleteSessionSuccess(response.sessionId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteSessionFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

// 
function* fetchSessionResults({ payload: filters }) {
  try {
    const response = yield call(getSessionResults, filters);
    console.log("SESSION RESULTS: ", response);
    yield put(getSessionResultsSuccess(response));
  } catch (error) {
    yield put(getSessionResultsFail(error));
  }
}

// Worker saga

/*
function* proclamerSessionSaga({ payload }) {
  try {
    const response = yield call(proclamerSessionApi, payload);
    console.log("PROCLAMATION RESPONSE: ", response);
    yield put(proclamerSessionSuccess());
    // 🆕 Recharger les résultats après proclamation
    yield put(getSessionResults({
      session_id:     payload.session_id,
      study_level_id: payload.study_level_id,
    }));
  } catch (error) {
    yield put(proclamerSessionFail(error));
  }
}

*/


function* proclamerSessionSaga({ payload }) {
  try {

    console.log("BEFORE SEND PROCLAMATION: ", payload);
    
    const response = yield call(proclamerSessionApi, payload);

    yield put(proclamerSessionSuccess(response));

    // Reload results after proclamation
    yield put(getSessionResults({
      session_uuid: payload.session_uuid,
      study_level_id: payload.study_level_id,
      semester_id: payload.semester_id,
      exam_uuid: payload.exam_uuid, // <--- AJOUTE CETTE LIGNE
      
    }));

  } catch (error) {
    yield put(proclamerSessionFail(error));
  }
}



// ───  Récupérer les résultats de proclamation ───────────────────────────────

function* getProclamationResultsSaga({ payload }) {
    try {
        const response = yield call(getProclamationResults, payload);
        console.log("PROCLAMATION RESULTS: ", response);
        yield put(getProclamationResultsSuccess(response));
    } catch (error) {
        yield put(getProclamationResultsFail(error));
    }
}






function* onSaveFinalDecision({ payload }) {
    try {
        const response = yield call(saveFinalDecision, payload);
        yield put(saveFinalDecisionSuccess(response));
        toast.success("Délibération enregistrée avec succès !");
    } catch (error) {
        yield put(saveFinalDecisionFail(error));
        toast.error("Échec de l'enregistrement de la délibération.");
    }
}


function* onRunAnnualDeliberation({ payload }) {
    try {
        console.log("BEFORE RUN DELIBERATION ON API", payload); 
        const response = yield call(runAnnualDeliberation, payload);
        console.log("RESPONSE FROM API", response); 
        yield put(runAnnualDeliberationSuccess(response));
        toast.success("Délibération terminée avec succès !");
    } catch (error) {
        yield put(runAnnualDeliberationFail(error));
        toast.error(error.response?.data?.message || "Erreur lors de la délibération");
    }
}



function* sessionSaga() {
    yield takeEvery(GET_SESSIONS, fetchSessions)
    yield takeEvery(ADD_NEW_SESSION, onAddNewSession)
    yield takeEvery(UPDATE_SESSION, onUpdateSession)
    yield takeEvery(DELETE_SESSION, onDeleteSession)
     yield takeEvery(GET_SESSION_RESULTS, fetchSessionResults); 

     yield takeEvery(PROCLAMER_SESSION, proclamerSessionSaga);

    yield takeEvery(GET_PROCLAMATION_RESULTS, getProclamationResultsSaga); // 🆕



    yield takeEvery(SAVE_FINAL_DECISION, onSaveFinalDecision);


    yield takeEvery(RUN_ANNUAL_DELIBERATION, onRunAnnualDeliberation);

}

export default sessionSaga;